<div class="absolute right-2 top-2 p-4">
  <app-language-menu></app-language-menu>
</div>
<div class="flex flex-col justify-center items-center w-full h-full p-4">
  <h2 class="text-2xl mb-6 text-center">
    {{ 'auth.login.passkey' | transloco }}
  </h2>
  <mat-card class="w-full max-w-md">
    <mat-card-content>
      <form novalidate [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="flex flex-col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'auth.login.passkeyKey' | transloco }}</mat-label>
            <mat-icon matPrefix>email</mat-icon>
            <input type="text" placeholder="Enter provided key" matInput formControlName="key" />
          </mat-form-field>

          <div class="p-2">
            <button
              class="w-full"
              type="submit"
              mat-raised-button
              color="primary"
              [disabled]="loginForm.invalid"
            >
              {{ 'shared.button.submit' | transloco }}
            </button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
